import { cx } from '@lastbrand/web-ui-styled-system/css'
import { useTranslation } from 'next-i18next'

import { FormattedPrice } from '@src/blocks/currency/currency.component'

import * as styles from './product-info-price-ds.styles'

export interface PerUnitOfferRowProps {
  festivalPricePerUnit?: number
  subscriptionOfferPricePerUnit?: number
  // Raw `purchaseOption === SUBSCRIBE`; unlike offer-value selection it does NOT require
  // `formattedSubscriptionPrice`, matching legacy.
  isSubscribePurchase: boolean
  traditionalPricePerServing?: number
  unitForPerServing: string
}

// Festival/subscription per-unit vs traditional-retail row; subscription per-unit price wins when subscribing.
// `priceWrapperMainMarginCss` (mt: space-4) matches the 4px the one-time state gets from
// ProductPriceDS's own `segmentGrowCss` gap between the price row and its savings caption — without it
// this row sat flush against the price when subscription was on, so toggling the purchase type shifted
// the block by 4px (STRFRNT-16528). Same spacing the sibling rows below the price block already use.
function PerUnitOfferRow({
  festivalPricePerUnit,
  subscriptionOfferPricePerUnit,
  isSubscribePurchase,
  traditionalPricePerServing,
  unitForPerServing,
}: PerUnitOfferRowProps) {
  const { t } = useTranslation('common')
  return (
    <div
      className={cx(
        styles.priceWrapperMainTextCss,
        styles.priceWrapperMainTextNewDesignV2Css,
        styles.priceWrapperMainMarginCss,
      )}
    >
      <span className={styles.priceWrapperMainValuePerservingTraditionalCss}>
        <FormattedPrice amount={traditionalPricePerServing} />
      </span>{' '}
      <FormattedPrice
        amount={
          subscriptionOfferPricePerUnit && isSubscribePurchase
            ? subscriptionOfferPricePerUnit
            : festivalPricePerUnit
              ? festivalPricePerUnit
              : ''
        }
      />
      /{t('per_unit_vs_traditional_retail', { value: unitForPerServing })}
    </div>
  )
}

export default PerUnitOfferRow
